export default {
  PRODUCTION: 'production',
  DEVELOP: 'develop',
};
